<template>
    <div
        :data-component-name="$options.name"
    >
        <div
            :class="{
                'o-label_w_tooltip': field.inputTooltip && field.inputTooltip.trim() != '',
                'has-instructions': showInstructions && field.inputInstructions && String(field.inputInstructions).trim() != ''
            }"
        >
            <label class="o-label" :for="'input-'+field.id" v-html="(field.inputRequired === true && String(field.inputLabel).trim()!='') ? field.inputLabel + '&nbsp;*' : field.inputLabel ">
            </label>
            <span 
                :id="'tooltip-' + field.id"
                class="o-form__tooltip__container"
                :class="{'is-active': tooltipActive}"
                v-if="field.inputTooltip && field.inputTooltip.trim() != ''"
            >
                <span class="o-form__tooltip__wrap" @click="tooltipActive = !tooltipActive">
                    <span class="o-form__tooltip" data-module="Tooltip" :data-target="'#tooltip-' + field.id" data-mid="m9">
                        <svgIco icon="question" class="o-o-ico" />
                    </span>
                </span>
                <span class="o-form__tooltip__content" v-html="field.inputTooltip" data-lenis-prevent>
                </span>
            </span>

            <div class="o-form__instruction" v-if="showInstructions && field.inputInstructions && (String(field.inputInstructions).trim() != '')">
                <small v-html="field.inputInstructions"></small>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Input-label',
    props: {
        field: {
            type: Object,
            default() {
                return {}
            },
        },
        showInstructions: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return {
            tooltipActive: false,
        }
    },
    mounted() {
    },
    computed: {
        fieldType() {
            switch (this.field.inputType) {
                case 'phone':
                    type = 'tel';
                    break;
                default:
                    type = this.field.inputType;
                    break;
            }

            return type;
        },
    },
    watch: {
        tooltipActive: function (val) {
            if (val) {
                document.addEventListener('click', this.closeTooltip);
            } else {
                document.removeEventListener('click', this.closeTooltip);
            }
        }
    },
    methods: {
        closeTooltip: function (e) {
            if (!this.$el.contains(e.target)) {
                this.tooltipActive = false;
            }
        }
    },
}
</script>